import type { PartnerConfig } from "@/content/partners/types"

export const PCYCLE_PARTNER_SLUG = "pcycle"

export const PCYCLE_LOGO_PATH = "/partners/pcycle/logo-mark.png"
export const PCYCLE_LOGO_DARK_PATH = "/partners/pcycle/logo-mark-light.png"
export const DAMATTA_LOGO_PATH = "/partners/pcycle/damatta-logo.jpg"
export const DAMATTA_GLASSES_IMAGE_PATH = "/partners/pcycle/oculos_da_matta_upscaled.png"
export const PCYCLE_HERO_IMAGE_PATH = "/partners/pcycle/hero-mtb.jpg"
export const PCYCLE_REGULAMENTO_OCULOS_PDF_PATH = "/partners/pcycle/regulamentos/regulamento-oculos-damatta.pdf"
export const PCYCLE_REGULAMENTO_ENERGIA_PDF_PATH = "/partners/pcycle/regulamentos/regulamento-energia-premiada.pdf"

/** Fim do dia 16/08/2026 America/Sao_Paulo (UTC−3). */
export const PCYCLE_CAMPAIGN_ACTIVE_UNTIL = "2026-08-17T02:59:59.999Z"

export const pcycleBrand = {
  accent: "#36B2FF",
  accentDark: "#002a50",
} as const

export const pcyclePartnerConfig: PartnerConfig = {
  slug: PCYCLE_PARTNER_SLUG,
  name: "P.cycle",
  fullName: "P.cycle",
  logoPath: PCYCLE_LOGO_PATH,
  benefitMode: "none",
  isActive: true,
  activeUntil: PCYCLE_CAMPAIGN_ACTIVE_UNTIL,
  metadata: {
    website: "https://www.pcycle.com.br/",
    campaign: "evento_ago_2026",
    event_dates: "2026-08-15/16",
    gift: "oculos_damatta",
    raffle: "creditos_fatura_astra_1000",
  },
}

/**
 * Copy da LP `/pcycle` alinhada ao layout da campanha.
 * Elegibilidade: assinatura aprovada até 16/08 (lifecycle active).
 */
export const pcyclePartnerContent = {
  slug: PCYCLE_PARTNER_SLUG,
  name: "P.cycle",
  fullName: "P.cycle",
  websiteUrl: "https://www.pcycle.com.br/",
  logoPath: PCYCLE_LOGO_PATH,
  logoDarkPath: PCYCLE_LOGO_DARK_PATH,
  damattaLogoPath: DAMATTA_LOGO_PATH,
  damattaGlassesImagePath: DAMATTA_GLASSES_IMAGE_PATH,
  heroImagePath: PCYCLE_HERO_IMAGE_PATH,
  regulamentoOculosPdfPath: PCYCLE_REGULAMENTO_OCULOS_PDF_PATH,
  regulamentoEnergiaPdfPath: PCYCLE_REGULAMENTO_ENERGIA_PDF_PATH,
  regulamentoLabel: "Ver regulamento",
  eventDatesLabel: "15 e 16 de agosto",
  deadlineLabel: "16 de agosto",

  heroKicker: "Parceria exclusiva · P.cycle Enduro Series",
  heroHeadlineBefore: "Economize até 25% na ",
  heroHeadlineHighlight: "conta de energia.",
  heroSubtitle:
    "Na parceria com o P.cycle, quem assinar por este link e tiver a assinatura aprovada até 16 de agosto ganha óculos DaMatta e concorre a R$ 1.000 em créditos na fatura Astra.",
  giftBadgeLabel: "Brinde da campanha",

  advantagesHeadline: "Vantagens da sua adesão",
  advantages: [
    { title: "Até 25% de desconto", description: "na conta de luz" },
    { title: "Uma única fatura", description: "simples de acompanhar" },
    { title: "Sem instalação", description: "nem obra no imóvel" },
    { title: "Sem taxa de adesão", description: "nem investimento inicial" },
    { title: "Painel online", description: "para acompanhar tudo" },
  ] as const,

  offerSectionKicker: "O que você recebe ao participar da campanha",
  offerHeadline: "Benefícios exclusivos da campanha",
  offerGiftTitle: "Óculos DaMatta",
  offerGiftText:
    "Receba gratuitamente um óculos DaMatta ao concluir uma adesão válida por esta campanha.",
  offerRaffleTitle: "Energia Premiada",
  offerRaffleHighlight: "R$ 1.000",
  offerRaffleHighlightSuffix: "em créditos na sua conta de energia.",
  offerRaffleText: "Concorra a R$ 1.000 em créditos na sua conta de energia.",

  stepsHeadline: "É simples participar",
  stepsLead:
    "Quatro passos. O que conta para brinde e sorteio é a assinatura aprovada até 16 de agosto.",
  steps: [
    {
      title: "Faça seu cadastro",
      text: "Comece por este link para vincular a assinatura à campanha P.cycle.",
    },
    {
      title: "Envie sua conta",
      text: "Use uma conta Cemig recente no cadastro.",
    },
    {
      title: "Assine digitalmente",
      text: "Conclua o processo online, sem obra e sem instalação.",
    },
    {
      title: "Retire o brinde",
      text: "No evento (15 e 16/08), com a assinatura aprovada, retire o óculos e concorra aos créditos.",
    },
  ] as const,

  simulatorKicker: "Simulador",
  simulatorHeadline: "Quanto você paga na conta de luz todo mês?",
  simulatorBody:
    "Ajuste o valor e o tipo de instalação para ver a economia estimada com a Astra.",
  simulatorBullets: [
    "Sem obras",
    "100% digital",
    "Sem investimento inicial",
    "Cancele quando quiser",
  ] as const,

  faqs: [
    {
      question: "Quem pode participar da campanha?",
      answer:
        "Quem se cadastrar por este link e tiver a assinatura Astra aprovada até 16 de agosto de 2026. Cadastro por outro caminho não entra no brinde nem no sorteio.",
    },
    {
      question: "O que preciso fazer para ganhar o óculos DaMatta?",
      answer:
        "Concluir o cadastro por este link e ter a assinatura aprovada até 16/08. A entrega é presencial no evento P.cycle, nos dias 15 e 16 de agosto, com o time Astra no local.",
    },
    {
      question: "Como funciona o sorteio de R$ 1.000?",
      answer:
        "Quem entrar pela campanha e tiver a assinatura aprovada até 16/08 concorre a R$ 1.000 em créditos. O valor abate na fatura Astra (cobrança da assinatura), não na conta Cemig.",
    },
    {
      question: "A Astra instala painéis no meu telhado?",
      answer:
        "Não. É energia solar por assinatura: a geração vem de usinas da Astra e você recebe desconto na conta de luz, sem obra e sem investimento inicial.",
    },
    {
      question: "A campanha muda o desconto da assinatura?",
      answer:
        "Não. O desconto segue o plano da Astra conforme o seu consumo. A campanha acrescenta o brinde DaMatta e a chance de ganhar créditos na fatura Astra.",
    },
  ] as const,

  ctaLabel: "Quero economizar",
  ctaDiscountLabel: "Quero esse desconto",
  ctaFinalHeadline: "Comece sua adesão hoje e economize na conta de energia",
  ctaFinalSubtitle:
    "Sem obra e sem investimento inicial. Para o óculos e o sorteio, a assinatura precisa estar aprovada até 16 de agosto.",

  disclaimer:
    "Créditos do sorteio abatem na fatura Astra (cobrança da assinatura), não na conta Cemig. Campanha válida para quem se cadastrar por este link e tiver a assinatura aprovada até 16/08/2026. Óculos DaMatta entregues presencialmente no evento P.cycle (15 e 16/08).",

  metaTitle: "P.cycle × Astra — óculos DaMatta e créditos na fatura",
  metaDescription:
    "Parceria Astra e P.cycle Enduro Series: assine por este link, economize na conta de energia, ganhe óculos DaMatta e concorra a R$ 1.000 em créditos na fatura Astra.",
} as const

export const PCYCLE_CADASTRO_HREF = `/cadastro?partner=${PCYCLE_PARTNER_SLUG}`
